import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

import { useSlug } from 'src/utils';

const query = graphql`
  query GetFromStudentCategoryMenus {
    japanese: allContentfulFromStudentCategory(
      sort: { date: ASC }
      filter: { node_locale: { eq: "ja" } }
    ) {
      nodes {
        title
        slug
        contentful_id
        from_student {
          id
        }
      }
    }
    english: allContentfulFromStudentCategory(
      sort: { date: ASC }
      filter: { node_locale: { eq: "en" } }
    ) {
      nodes {
        title
        slug
        contentful_id
        from_student {
          id
        }
      }
    }
  }
`;

export const useFromStudentCategoryMenus = () => {
  const { japanese, english } =
    useStaticQuery<Queries.GetFromStudentCategoryMenusQuery>(query);
  const { lang } = useSlug();
  return useMemo(() => {
    const list = lang === 'ja' ? japanese : english;
    return list.nodes
      .filter((item) => item.from_student && item.from_student.length > 0)
      .map((item) => ({
        id: item?.contentful_id,
        name: 'from-student',
        label: item?.title ?? 'no label',
        href: item?.slug
          ? `/from-student/category/${item.slug}/`
          : '/from-student/',
      }));
  }, [japanese, english, lang]);
};
